// Scene枚举定义 https://yapi.hellobike.cn/project/3415/interface/api/324078
export enum ContractScene {
  CREDIT = '01', // 授信
  APPLY = '02', // 提现
}

// 邮件发送结果枚举定义 https://yapi.hellobike.cn/project/3415/interface/api/324853
export enum SendEmailResult {
  SUCCESS = 1, // 成功
  FAILED = 2, // 失败
}
